// extracted by mini-css-extract-plugin
export default {"overlay":"Ev-z","bodyOpen":"Fv-z","content":"Gv-z","header":"Hv-z","close":"Iv-z","closeNoHeading":"Jv-z"};